import { __ } from '@wordpress/i18n'

export default {
  searchPlaceholder: __('Suche', 'dhsv_theme'),
  moreButton: __('Mehr erfahren', 'dhsv_theme'),
  loadMoreButton: __('Mehr anzeigen', 'dhsv_theme'),
  loading: __('Wird geladen...', 'dhsv_theme'),
  postsNotFound: __('Blog posts not found!', 'dhsv_theme'),
  selectFilter: __('Filter wählen', 'dhsv_theme'),
}
